import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { toast } from 'react-toastify';
import Loader from "../../../Components/Loader";
import Select from 'react-select';
import {locationServices} from "../../../Services"
import SimpleReactValidator from 'simple-react-validator';
import CourierCountryServices from "../../../Services/CourierCountryServices";

const ProviderOption = [
    { value: 'Fedex', label: 'Fedex'},
    { value: 'Ups', label: 'Ups'},
    { value: 'Dhl', label: 'Dhl'}
]

const serviceOption = [
    { value: 'EXPORT', label: 'Export'},
    { value: 'IMPORT', label: 'Import'}
]

let ObjNum = [];
for (let i = 0; i < 75; i++) {
    ObjNum.push({ value: i, label: i})
}
const ZoneOption = ObjNum

export const AddCourierCountryService = () => {

    const history = useHistory()

    const [, setForceUpdate] = useState('')
    const validator = useRef(new SimpleReactValidator({ autoForceUpdate: { forceUpdate: setForceUpdate } }))

    const [countryList, setCountryList] = useState([])
    
    const [serviceProvider, setServiceProvider] = useState()
    const [zone, setZone] = useState({ value: '', label: '' })
    const [serviceType, setServiceType] = useState()
    const [countryItem, setCountryItem] = useState([])
    const [inputZone, setInputZone] = useState()
    const [isShow, setIsShow] = useState(false)

    useEffect(() => {
        getCountryList();
        getZonedetail();
    },[])

    const getCountryList = () => {
        locationServices.getCountry({ page: 1, limit: 300 }).then((res) => {
          if (res.status) {
            let arry = [];
            res.data.map((list) => {
              arry.push({ value: list._id, label: list.country_name });
            });
            setCountryList(arry);
          }
        });
      };

      const getZonedetail = () => {
        CourierCountryServices.getCourierZoneApi().then((res) => {
          if (res.status) {
              let zoneArry = []
            res.data.map(val=>{
                ZoneOption.map(item=>{
                    if(item.value === val.zone){
                        zoneArry.push({value: item.value, label: item.label})
                    }
                })
            })
            setZone(zoneArry)
            if(res.data.length > 0){
                setIsShow(true)
            }
          }
        });
      };

      const submitHandler = (e) =>{
          e.preventDefault();

        let validate;
          if(inputZone){
            validate = +
              validator.current.fieldValid('zone') &&
              validator.current.fieldValid('service provider') &&
              validator.current.fieldValid('service type') &&
              validator.current.fieldValid('countries');
          }else{
            validate = +
            validator.current.fieldValid('zone select') &&
              validator.current.fieldValid('service provider') &&
              validator.current.fieldValid('service type') &&
              validator.current.fieldValid('countries');
          }

          console.log(validate)

        //   if(zone){
            
        //   }

          let idArry = []
          if(countryItem) {
            countryItem.forEach((item=>{
                idArry.push(item.value)
            }))
        }

         let postData = {
            service_provider: serviceProvider && serviceProvider.value,
            zone: inputZone ? inputZone : zone.value,
            service_type: serviceType && serviceType.value,
            countries: idArry
         }
         
        // const validate = validator.current.allValid()
        if(validate && postData.zone){
            CourierCountryServices.addCouriercountryApi(postData).then((res) => {
                if (res.status === true) {
                  history.push('/courier-country-service')
                  toast.success('courier country created successfully');
                }else{
                    toast.error(res.message)
                }
              }).catch(err=>{
                  console.log(err)
              });

        }else{
            validator.current.showMessages();
        }

      }  

  return (
    <div className="row d-flex justify-content-center">
    <div className="col-lg-8">
        <div className="card">
            <div className="card-body">
                <form className="control-form" onSubmit={(e) => submitHandler(e)}>
                    <div className="row">
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Service Provider</label>
                            </div>
                            <div className="col-9">
                                 <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            boxShadow: '0 0 0 0px #f46a6a',
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    // value={destinationCountryValue}
                                    onChange={(e) => setServiceProvider(e)}
                                    placeholder="Select Service Provider"
                                    options={ProviderOption}
                                />
                                {validator.current.message("service provider",serviceProvider,"required",{ className: "text-danger" })}
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Zone</label>
                            </div>
                            <div className="col-9">
                                <div className="d-flex">
                                
                                <input 
                                    type="text"
                                    className="form-control w-50 me-3"
                                    placeholder="Enter Zone"
                                    onChange={(e) => setInputZone(e.target.value)}
                                />
                               
                                <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            boxShadow: '0 0 0 0px #f46a6a'
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    className="w-50"
                                    isMulti={false}
                                    value={zone}
                                    onChange={(e) => setZone(e)}
                                    placeholder="Select Zone"
                                    options={ZoneOption}
                                />
                                  </div>

                                  <div className="d-flex">
                                      <div className="w-50 me-3">
                                      {zone && !zone.value && validator.current.message("zone",inputZone,"required",{ className: "text-danger" })}
                                      </div>
                                      <div>
                                      { !inputZone && validator.current.message("zone select",zone,"required",{ className: "text-danger" })}
                                      {
                                        isShow === true ?
                                      <div><small className="text-muted">(already added zone)</small></div>
                                      :
                                      null
                                      }
                                      </div>
                                  </div>
                                    
                                        
                                  
                                    

                                
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Service Type</label>
                            </div>
                            <div className="col-9">
                                <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            boxShadow: '0 0 0 0px #f46a6a'
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    // value={destinationCountryValue}
                                    onChange={(e) => setServiceType(e)}
                                    options={serviceOption}
                                    placeholder="Select Service Type"
                                />
                               

                                {validator.current.message("service type",serviceType,"required",{ className: "text-danger" })}
                            </div>
                        </div>
                        <div className="mb-3 row">
                            <div className="col-3">
                                <label className="form-label" >Countries</label>
                            </div>
                            <div className="col-9">
                                <Select
                                    styles={{
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: 'calc(2.15rem + 2px)',
                                            overflowY: 'visible'
                                        }),
                                        control: (provider) => ({
                                            ...provider,
                                            boxShadow: '0 0 0 0px #f46a6a'
                                        }),
                                        placeholder: (provider) => ({
                                            ...provider,
                                            color: '#a0b0ca'
                                        })
                                    }}
                                    isMulti
                                    className="customCourierSelect"
                                    onChange={(e) => setCountryItem(e)}
                                    options={countryList}
                                    placeholder="Select Countries"
                                />
                               

                                {validator.current.message("countries",countryItem,"required",{ className: "text-danger" })}
                            </div>
                        </div>
                       
                    </div>
                    <div className="mt-3 d-flex justify-content-between">
                        <button
                            className="btn btn-danger w-sm waves-effect waves-light"
                            type="button"
                            onClick={() => history.goBack()}
                        >Back</button>
                        <button className="btn btn-primary w-sm waves-effect waves-light"
                            type="submit"
                            
                        >Submit</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
  );
};
